import iconClose from '../img/icons/icon-close.svg';
import iconSearch from '../img/icons/icon-search.svg';
import PropTypes from 'prop-types';
import React from 'react';
import SearchClearOrBusy from './SearchClearOrBusy';


export default class ButtonInput extends React.Component{
  state = {
    hasText: false,
  };


  constructor(){
    super();
    this.queryInputRef = React.createRef();
  }

  componentDidMount(){
    this.syncHasText(this.props.defaultValue);
  }

  componentDidUpdate(prevProps){
    if(prevProps.defaultValue !== this.props.defaultValue){
      this.syncHasText(this.props.defaultValue);
      if(this.queryInputRef.current && typeof this.props.defaultValue !== 'undefined'){
        this.queryInputRef.current.value = this.props.defaultValue || '';
      }
    }
  }

  syncHasText = value => {
    const hasText = Boolean(value && String(value).length > 0);
    if(hasText !== this.state.hasText){
      this.setState({hasText});
    }
  };

  onClearClick = (e) => {
    if(e && e.preventDefault){
      e.preventDefault();
      e.stopPropagation();
    }
    if(this.queryInputRef.current){
      this.queryInputRef.current.value = '';
    }
    this.syncHasText('');
    this.props.onClearClick ? this.props.onClearClick() : null;
  };
  onInputChange = (e) => {
    this.syncHasText(e.target.value);
    this.props.onInputChange ? this.props.onInputChange(e) : null;
  };


  handleKeyDown = event => {
    if(!this.props.onSubmit || event.key !== 'Enter'){
      return;
    }
    // Inputs inside a <form> already submit on Enter; skip so onSubmit is not called twice
    // (and not called without the form event listing pages need).
    if(event.target && event.target.form){
      return;
    }
    event.preventDefault();
    const clearResults = this.props.onSubmit(event);
    if(clearResults) this.onClearClick();
  };


  renderX = () => {
    if(this.props.isLoading){
      return <SearchClearOrBusy isLoading={true}/>;
    }
    if(!this.props.showX && !this.state.hasText) return null;

    return (
      <SearchClearOrBusy iconSrc={iconClose} onClear={this.onClearClick}/>
    );
  };
  getInputA11yProps(){
    if(this.props.ariaLabelledBy){
      return {'aria-labelledby': this.props.ariaLabelledBy};
    }
    if(this.props.inputAriaLabel){
      return {'aria-label': this.props.inputAriaLabel};
    }
    return {};
  }

  render(){
    //console.log(`ButtonInput.render()`, this.props);

    let inputPlaceholder = this.props.inputPlaceholder || 'Search';

    return (
      <div className="button-input">
        <button aria-label="Search" className="button-input__button button-input__button--search" type="submit">
          <img alt="" className="button-input__button-icon" src={iconSearch}/>
        </button>

        <input {...this.getInputA11yProps()}
               className={`button-input__input input ${this.props.className || ''} ${this.props.isOpen ? 'search-input-open' : ''}`.trim()}
               defaultValue={this.props.defaultValue}
               id={this.props.inputID}
               type="text"
               name="query"
               placeholder={inputPlaceholder}
               required={this.props.required}
               aria-busy={this.props.isLoading ? true : undefined}
               onChange={this.onInputChange}
               onKeyDown={this.handleKeyDown}
               ref={this.queryInputRef}/>

        {this.renderX()}
      </div>
    );
  }
}


ButtonInput.propTypes = {
  ariaLabelledBy: PropTypes.string,
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  inputAriaLabel: PropTypes.string,
  inputID: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClearClick: PropTypes.func,
  onInputChange: PropTypes.func,
  onSubmit: PropTypes.func,
  required: PropTypes.bool,
  showX: PropTypes.bool
};
